export default "__VITE_ASSET__CS3sZ1Gz__"